import React, { Component } from 'react'
import { connect } from 'react-redux'

import { translation } from '../../../utils/helpers'
import { closeSlidePanel, isSlidePanelOpen } from '../../../actions/common'
import './slidePanel.scss'

class SlidePanel extends Component {

  componentWillUnmount () {
    // Force remove slidePanelId from stack when unmounting
    this.props.closeSlidePanel(this.props.slidePanelId, true)
  }

  render () {
    if (!this.props.isSlidePanelOpen(this.props.slidePanelId)) return null
    let slidePanelClass = 'element-slidePanel'
    if (this.props.extraClassName) slidePanelClass += ` ${this.props.extraClassName}`
    if (this.props.isLoading) slidePanelClass += ' isLoading'
    return (
      <div className={slidePanelClass}>
        {this.props.isLoading && (
          <div className='loadingBackdrop'>
            <span className='animated-background'>
              <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
              <span className='sr-only'>{translation('13382')}...</span>
            </span>
          </div>
        )}
        {this.props.children}
      </div>
    )
  }
}

SlidePanel.contextTypes = {
  router: React.PropTypes.object.isRequired
}

SlidePanel.propTypes = {
  slidePanelId: React.PropTypes.string.isRequired
}

SlidePanel.defaultProps = {
  isLoading: false
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    slidePanelsLength: state.common.slidePanels.length  // (makes react detect the change, not sure why it doesn't detect this through the array)
  }
}

export default connect(mapStateToProps, {
  closeSlidePanel,
  isSlidePanelOpen
})(SlidePanel)



// WEBPACK FOOTER //
// ./src/app/shared/elements/slidePanel/index.js